/** Matches the five half-point checks in the legacy store renderer (`app.ts`). */
const STAR_FILL_THRESHOLDS = [0.5, 1.5, 2.5, 3.5, 4.5] as const;

export const STORE_PRODUCT_STAR_COUNT = STAR_FILL_THRESHOLDS.length;

/** Non-numeric values become 0; anything outside 0–5 (including ±Infinity) is clamped. */
export function clampReviewScore(reviewScore: number): number {
    const score = Number(reviewScore);
    if (Number.isNaN(score)) {
        return 0;
    }

    return Math.min(STORE_PRODUCT_STAR_COUNT, Math.max(0, score));
}

/**
 * How many of the five store-card stars should be filled.
 *
 * Legacy behavior is exclusive half-points (`score > 0.5`, `> 1.5`, … `> 4.5`),
 * not integer rounding: 0.4 → 0, 0.6 → 1, 4.1 → 4, 4.6 → 5.
 * Non-finite and out-of-range scores are clamped to 0–5.
 */
export function getFilledStarCount(reviewScore: number): number {
    const clamped = clampReviewScore(reviewScore);

    let filled = 0;
    for (const threshold of STAR_FILL_THRESHOLDS) {
        if (clamped > threshold) {
            filled += 1;
        }
    }

    return filled;
}
